const taskTemplates = require('../../task-templates');

const tasksData = [		
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		image: 'htx-it-it-1',
		title: 'Opgave 1',
		taskId: 'it-multiple-choice-programming-languages',
		text: 'Når man skriver kode, gør man det i et sprog – altså en bestemt måde at skrive på, som computeren kan forstå. Kun tre af følgende er programmeringssprog.',
		hintText: `Prøv at google ét af navnene og se, om det bliver brugt til at skrive kode.`,
		popupText: `På HTX arbejder man med kode, fordi IT og teknologi fylder meget i moderne virksomheder.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Python', 
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'JavaScript', 
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'C#', 
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Panda', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'C!', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6,
				text: 'Mokka', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 7,
				text: 'Tysk', 
			}),
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'it-input-answer-count-squares',
		text: `Programmering handler i høj grad om logik og om at kunne genkende mønstre. Kig på figuren. Hvor mange kvadrater kan I se?`,
		hintText: `Der er også firkanter i firkanterne.`,
		popupText: `At finde mønstre og tænke logisk er en stor del af programmering. Det er præcis den måde at tænke på, man arbejder med på HTX.`,
		answer: 34,
		unit: 'kvadrater',
		image: 'it-squares'
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		image: 'htx-it-it-2',
		title: 'Opgave 3',
		taskId: 'it-multiple-choice-op-sys',
		text: `Hvilke tre af disse er styresystemer til computere?`,
		hintText: `Prøv at google navnet + “styresystem” og se, om det bruges til at køre en computer.`,
		popupText: `På HTX arbejder man med IT-systemer for at forstå, hvordan teknologi fungerer i praksis.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Microsoft Windows', 
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'macOS', 
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Apple', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Ubuntu', 
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Huawei', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6,
				text: 'Disk', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 7,
				text: 'Nokia', 
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 4,
		image: 'htx-it-it-3',
		title: 'Opgave 4A',
		taskId: 'it-multiple-choice-router-issues',
		text: `Wi-fi virker ikke i kommunikationsafdelingen. Routeren er tændt, men computerne har intet signal. Hvad gør I?`,
		hintText: `Start altid med den enkleste løsning, før I ændrer udstyr eller opsætning.`,
		popupText: 'På HTX lærer man at finde fejl systematisk, ligesom man gør i virkelige IT-afdelinger.',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Genstarter routeren', 
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Installerer nye netværkskort i afdelingens computere', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Sætter en ny router op', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Trækker fysiske kabler til alle computerne i afdelingen', 
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 5,
		image: 'htx-it-it-4',
		title: 'Opgave 4B',
		lockedById: 'it-multiple-choice-router-issues',
		taskId: 'it-multiple-choice-wifi-off',
		text: `Det viser sig, at problemet ikke var routeren, men medarbejdere, der havde slukket for wi-fi på deres computere. Hvad kalder man i teknikerslang den slags fejl, som opstår, fordi brugeren gør noget forkert?`,
		hintText: `Det er et ord, voksne og teknikere bruger, når fejlen skyldes tastatur eller brugerens handlinger.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Teknisk fejl', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Fejl 40', 
				isCorrect: true,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Fingerfejl', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Rookie mistake', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: 'Epic fail', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6,
				text: 'N00b fejl', 
			}),
		],
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 1,
	// 	taskNumber: 1,
	// 	subtype: 'images',
	// 	title: 'Opgave 1A',
	// 	taskId: 'it-multiple-choice-designguide-1',
	// 	text: `I skal designe en varedeklaration.
	// 		<br /><br />Hvilken farve skal overskriften have ifølge designguiden?`,
	// 	layout: 'it-designguide',
	// 	image: 'it-product-1',
	// 	imageSolved: 'it-product-2',
	// 	files: [
	// 		{
	// 			id: 'it-guide',
	// 			type: 'image',
	// 			btnText: 'Se designguide',
	// 		}
	// 	],
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'concern', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'design', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'production' 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'contrast-purple',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'secondary-lime',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'contrast-yellow',
	// 		}),
	// 	],
	// }),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 1,
	// 	taskNumber: 1.3,
	// 	lockedById: 'it-multiple-choice-designguide-1',
	// 	subtype: 'images',
	// 	title: 'Opgave 1B',
	// 	taskId: 'it-multiple-choice-designguide-2',
	// 	text: `I skal designe en varedeklaration.
	// 		<br /><br />Hvilken farve skal indholdsfortegnelsen have ifølge designguiden?`,
	// 	layout: 'it-designguide',
	// 	image: 'it-product-2',
	// 	imageSolved: 'it-product-3',
	// 	files: [
	// 		{
	// 			id: 'it-guide',
	// 			type: 'image',
	// 			btnText: 'Se designguide',
	// 		}
	// 	],
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'production', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'research', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'secondary-lime', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'design',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'contrast-purple',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'contrast-yellow',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'contrast-orange',
	// 		}),
	// 	],
	// }),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 1,
	// 	taskNumber: 1.6,
	// 	lockedById: 'it-multiple-choice-designguide-2',
	// 	subtype: 'images',
	// 	title: 'Opgave 1C',
	// 	taskId: 'it-multiple-choice-designguide-3',
	// 	text: `I skal designe en varedeklaration.
	// 	<br /><br />Hvilke farver skal linksene have ifølge designguiden?`,
	// 	layout: 'it-designguide',
	// 	image: 'it-product-3',
	// 	imageSolved: 'it-product-3-solved',
	// 	files: [
	// 		{
	// 			id: 'it-guide',
	// 			type: 'image',
	// 			btnText: 'Se designguide',
	// 		}
	// 	],
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'contrast-yellow', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'contrast-orange', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'contrast-red', isCorrect: true 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'design',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'secondary-lime',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 'production',
	// 		}),
	// 	],
	// }),
	// Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
	// 	caseId: 1,
	// 	taskNumber: 2,
	// 	taskId: 'it-order-print',
	// 	layout: 'double-height',
	// 	title: 'Opgave 2',
	// 	text: `Danish Nutrition har fokus på bæredygtighed, og derfor skal varedeklarationerne trykkes på genanvendt papir. Trykkeriet mener ikke, at det er muligt at trykke koncernfarven på det genanvendte papir og foreslår, at farven ændres.
	// 	<br />Diskutér følgende valgmuligheder og placer dem i rækkefølge fra bedst til værst.`,
	// 	items: [
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'normal-paper', 
	// 			text: `Vi trykker etiketterne på normalt papir, så vi kan følge designguiden.`,
	// 			correctOrderNumbers: [1]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'sustainable-paper', 
	// 			text: `Bæredygtighed frem for alt. Vi trykker etiketterne i andre farver.`,
	// 			correctOrderNumbers: [2]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'new-design-guide', 
	// 			text: `Vi laver designguiden om og ændrer farver på vores andre produkter.`,
	// 			correctOrderNumbers: [3]
	// 		}),
	// 		Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
	// 			id: 'no-print', 
	// 			text: `Vi trykker ikke etiketter til insulinpakkerne.`,
	// 			correctOrderNumbers: [4]
	// 		})
	// 	]
	// }),
	// Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
	// 	caseId: 1,
	// 	taskNumber: 3,
	// 	taskId: 'it-sort-colors',
	// 	title: 'Opgave 3',
	// 	text: `I forbindelse med lanceringen af ny medicin skal der designes t-shirts til sælgerne. Vælg de tre farver, som t-shirten skal have ifølge designguiden.	`,
	// 	categories: [
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'dominating', 
	// 			title: `Den dominerende farve`
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'text', 
	// 			title: `Skriften på t-shirten`
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
	// 			id: 'links', 
	// 			title: `Links/SoMe-hashtags`
	// 		}),
	// 	],
	// 	items: [
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 1, 
	// 			text: `Koncernfarven`,
	// 			categoryIds: ['dominating']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 2, 
	// 			text: `Cyan eller lime`,
	// 			categoryIds: ['text']
	// 		}),
	// 		Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
	// 			id: 3, 
	// 			text: `Sekundære kontrastfarver`,
	// 			categoryIds: ['links']
	// 		})
	// 	]
	// }),


	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		taskId: 'it-communication-order-print',
		layout: 'double-height',
		title: 'Opgave 1',
		text: `Nordic BioLab har fokus på bæredygtighed og vil bruge genanvendt papir, men trykkeriet kan ikke ramme virksomhedens farve. Sæt valgene i rækkefølge efter jeres bedste bud for at hjælpe virksomheden.`,
		hintText: `Hvad tror I, en stor medicinalvirksomhed ville prioritere højest?`,
		popupText: `På HTX arbejder man med at finde den bedste løsning, når krav støder sammen i virkeligheden.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'normal-paper', 
				text: `Vi trykker etiketterne på normalt papir, så vi kan følge designguiden.`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'sustainable-paper', 
				text: `Bæredygtighed frem for alt. Vi trykker etiketterne i andre farver.`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'new-design-guide', 
				text: `Vi laver designguiden om og ændrer farver på vores andre produkter.`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'no-print', 
				text: `Vi trykker ikke etiketter til insulinpakkerne.`,
				correctOrderNumbers: [4]
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		image: 'htx-it-communication-1',
		title: 'Opgave 2',
		taskId: 'it-multiple-choice-four-ps',
		text: `Design- og kommunikationsafdelingen bruger de såkaldte “4 P’er”: Price (pris), Promotion (markedsføring), Place (distribution) og Product (produkt). Hvad kaldes de fire P’er samlet for hos Nordic BioLab?`,
		hintText: `Hvad kalder man virksomhedens plan for salg og markedsføring?`,
		popupText: `De 4 P’er bruges i markedsføring og er noget, man lærer om på gymnasiet.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'En virksomhedsfilosofi', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: `En virksomhedspræsentation`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: `Deres kerneværdier`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: `En reklametekst`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: `En markedsføringsstrategi`,
				isCorrect: true 
			}),
		],
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		taskId: 'it-order-marked-strategy',
		layout: 'double-height',
		title: 'Opgave 3',
		text: `En markedsføringsstrategi består af tre faser. Sæt dem i den rigtige rækkefølge.`,
		hintText: `Tænk over, hvordan virksomheder går fra idé til handling – og bagefter tjekker, om det virkede.`,
		popupText: `På HTX arbejder man med markedsføring som en proces. Det handler om at planlægge, udføre og evaluere, så virksomheder træffer bedre beslutninger.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'planning', 
				text: `Planlægning`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'implementing', 
				text: `Udførelse`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'evaluation', 
				text: `Evaluering`,
				correctOrderNumbers: [3]
			})
		]
	}),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 2,
	// 	taskNumber: 3,
	// 	title: 'Opgave 3',
	// 	taskId: 'it-multiple-choice-choose-media',
	// 	text: `I forlængelse af markedsføringsstrategien skal der udvælges to medier, hvor der skal reklameres for den nye insulin. Vælg de to bedste medier til at annoncere på.`,
	// 	popupText: 'Da Danish Nutrition hurtig sælger deres produkter til offentlige institutioner og virksomheder og ikke til private, er det bedst, at de viser deres produkter på hjemmesiden og ved at kontakte deres kunder direkte via telefon. Virksomheder er ikke på de sociale medier på samme måde, som private er.',
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1,
	// 			text: 'TikTok', 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2,
	// 			text: `Instagram`, 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3,
	// 			text: `Facebook`, 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4,
	// 			text: `Youtube`, 
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5,
	// 			text: `Hjemmeside`,
	// 			isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 6,
	// 			text: `Aviser`,
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 7,
	// 			text: `Streamingtjenester`,
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 8,
	// 			text: `Telefonopkald`,
	// 			isCorrect: true
	// 		}),
	// 	],
	// }),
Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		taskId: 'it-sort-combine-colors',
		title: 'Opgave 1',
		text: `I skal vælge farver til indpakningen. Hvilken ny farve får I, når I blander de farver, I har på lager?`,
		hintText: `Tænk på farvelæren: Rød, gul og blå er grundfarver, som kan blandes til nye farver.`,
		popupText: `Farveblanding bruges i design, markedsføring og produktion. På HTX arbejder man med farver som en del af visuel kommunikation.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'orange', 
				title: `Orange`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'green', 
				title: `Grøn`
			}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {
				id: 'violet', 
				title: `Violet`
			}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 1, 
				text: `Rød og Gul`,
				categoryIds: ['orange']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 2, 
				text: `Gul og blå`,
				categoryIds: ['green']
			}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {
				id: 3, 
				text: `Rød og blå`,
				categoryIds: ['violet']
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		image: 'htx-it-new-wrap-1',
		title: 'Opgave 2A',
		taskId: 'it-multiple-choice-color-circle',
		text: `Når man arbejder med farver, kan man blandt andet bruge den tolvdelte farvekreds. Kig på figuren. Hvad kalder man farverne i den yderste ring?`,
		hintText: `Prøv at google “tolvdelt farvekreds” og se, hvad farverne yderst kaldes.`,
		popupText: `På HTX arbejder man med farveteori for at forstå design og visuel kommunikation i praksis.`,
		
		options: [							
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Tertiære farver', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: `Sekundære farver`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: `Primære farver`,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: `Koncernfarver`, 
			}),
		],
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		image: 'htx-it-new-wrap-1',
		title: 'Opgave 2B',
		taskId: 'it-multiple-choice-complimentary',
		text: `Komplementærfarver er farver, som står i kontrast til hinanden. Kig nu på ringen i figuren. Hvad er røds komplementærfarve?`,
		hintText: `Find rød på farvekredsen og kig direkte over på den modsatte side.`,
		lockedById: 'it-multiple-choice-color-circle',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Grøn cirkel', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: `Gul cirkel`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: `Orange cirkel`,
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: `Turkis cirkel`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5,
				text: `Blå cirkel`, 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6,
				text: `Lilla cirkel`, 
			}),
		],
	}),
	// case 4
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 1,
		image: 'htx-it-rules-1',
		title: 'Opgave 1',
		taskId: 'it-multiple-choice-rules',
		text: `Hvilke regler gælder for at reklamere for lægemidler til offentligheden?`,
		hintText: `Receptpligtig medicin er noget, man kun får via læge – og derfor må det ikke reklameres direkte til almindelige forbrugere.`,
		popupText: `På HTX arbejder man med regler og ansvar, når produkter skal på markedet.`,
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1,
				text: 'Nordic BioLab må betale læger for at rose produktet og anbefale det til deres patienter', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2,
				text: 'Nordic BioLab må ikke reklamere for deres lægemiddel direkte til forbrugere, da det er receptpligtig medicin', 
				isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3,
				text: 'Nordic BioLab kan kontakte et reklamebureau og få dem til at reklamere for lægemidlet til offentlige forbrugere', 
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4,
				text: 'Nordic BioLab må betale patientforeninger for at lave en kampagne for lægemidlet direkte til offentlige forbrugere', 
			}),
		],
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 4,
		taskNumber: 2,
		taskId: 'it-order-marked-diabetes',
		layout: 'double-height',
		title: 'Opgave 2',
		text: `Som medarbejdere hos Nordic BioLab skal I vurdere, hvilke konsekvenser af diabetes der er mest alvorlige, så virksomheden kan fokusere på de vigtigste problemer. Sortér dem i rækkefølge fra værst til mindst alvorlig.`,
		hintText: `Tænk på hvilke konsekvenser der kan give varige skader på kroppen, og hvilke der handler mere om hverdagsvaner.`,
		popupText: `På HTX arbejder man med at vurdere konsekvenser og prioritere, så virksomheder kan fokusere på det vigtigste.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'blindness', 
				text: `Risiko for svækket syn, blindhed og nyresygdom`,
				correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'footulcers', 
				text: `Øget risiko for fodsår og i sjældne tilfælde koldbrand`,
				correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'evaluation', 
				text: `Krav om daglig kontrol af blodsukker, blodtryk og kolesteroltal samt medicin`,
				correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 'active', 
				text: `Behov for sund kost og fysisk aktivitet`,
				correctOrderNumbers: [4]
			}),
		]
	}),
	// case 5
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 5,
	// 	taskNumber: 1,
	// 	title: 'Opgave 1A',
	// 	taskId: 'it-multiple-choice-design-colors',
	// 	text: `Kig på designguiden. Hvilke to farver tror I ledelsen har valgt til den nye hjemmeside?`,
	// 	popupText: null,
	// 	files: [
	// 		{
	// 			id: 'color-guide',
	// 			type: 'image',
	// 			btnText: 'Se designguide',
	// 		}		
	// 	],
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1, text: 'Orange', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2, text: 'Blå'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3, text: 'Rosa',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4, text: 'Violet'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5, text: 'Gul',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 6, text: 'Turkis ', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 7, text: 'Rød'
	// 		})
	// 	],
	// }),
	// Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
	// 	caseId: 5,
	// 	taskNumber: 2,
	// 	title: 'Opgave 1B',
	// 	taskId: 'it-multiple-choice-url',
	// 	lockedById: 'it-multiple-choice-design-font',
	// 	text: `Vælg den URL der passer bedst til hjemmesiden.`,
	// 	popupText: null,
	// 	hintText: `Bindestreger er ikke gode i hjemmesider, og com er bedre til salg over landegrænsen.`,
	// 	image: 'it-url',
	// 	options: [
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 1, text: 'www&period;danishnutrition.dk'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 2, text: 'www&period;danishnutrition.com', isCorrect: true
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 3, text: 'www&period;danishnutrition.tv',
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 4, text: 'www&period;danish-nutrition.dk'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 5, text: 'www&period;danish-nutrition.com'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 6, text: 'www&period;danishnutrition.nu'
	// 		}),
	// 		Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
	// 			id: 7, text: 'www&period;danish-nutrition.nu'
	// 		}),


	// 	],
	// }),

];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'htx-it-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};